import { render, staticRenderFns } from "./CreateName.vue?vue&type=template&id=7932661c&"
import script from "./CreateName.vue?vue&type=script&lang=js&"
export * from "./CreateName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports